import * as _ from 'lodash';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MatToolbar, MatSnackBar } from '@angular/material';
import { AuthService } from 'src/app/services/auth.service';
import { LocaleService } from 'src/app/services/locale.service';
import { AppConfigService } from 'src/app/services/app-config.service';

import { ClaimsService } from 'src/app/services/claims.service';

import { Claim } from 'src/app/models/claim';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ks-toolbar',
    templateUrl: './ks-toolbar.component.html',
    styleUrls: ['./ks-toolbar.component.scss']
})
export class KsToolbarComponent implements OnInit {

    authUserScope: string;
    allowedModules: object;

    claimId: string;

    printing: boolean;

    state = {
        saving: false,
        isMenuOpen: false,
        isUserMenuOpen: false,
        isLanguageMenuOpen: false,
        loading: false,
        deleting: false,
        isAdmin: false,
        error: ''
    };
    parentLink: string;
    subTitle: string;

    @Input() appInfo: any;
    // @Input() subTitle: string;
    @Input() file: string;
    @Input() hasMenu: boolean;
    @Input() hasBack: boolean;

    @Output() back = new EventEmitter();
    // @Output() changeLanguage = new EventEmitter();

    public publicUse: boolean;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private snackBar: MatSnackBar,
        private authService: AuthService,
        private localeService: LocaleService,
        private appConfigService: AppConfigService,
        private claimsService: ClaimsService
    ) {
    }

    ngOnInit() {
        this.state.loading = false;

        const environment = this.appConfigService.config.environment;

        this.router.events.subscribe((ev) => {
            if (ev instanceof NavigationEnd) {
                const routeData = this._getCurrentRouteData();
                if (routeData && routeData[0] && routeData[0].path) {
                    this.parentLink = routeData[0].path;
                    this.subTitle = routeData[0].path.replace('-', ' ');
                    console.log('subTitle', this.subTitle);
                } else {
                    this.subTitle = null;
                }
                // Set menu allowedModules by user.permissions.mudules
                if (this.authService.userProfile) {
                    this.allowedModules = this.authService.userProfile.permissions.modules;
                    this.authUserScope = this.authService.userProfile.permissions.scope;
                    console.log('ks-toolbar allowedModules', this.allowedModules);
                }
            }
            // Disable public use on prod environment before publish date 3.6.2019
            this.publicUse = true;
            if (environment === 'prod' && new Date() < new Date('2019-06-03 00:00:00.000Z')) {
                this.publicUse = false;
            }
        });
    }

    _getCurrentRouteData() {
        let currentRoute = this.route.root;
        while (currentRoute.children[0] !== undefined) {
            currentRoute = currentRoute.children[0];
        }
        this.printing = currentRoute.snapshot.queryParams['print'] === 'true' ? true : false;
        const routeData = <any>currentRoute.snapshot.url;
        return routeData;
    }

    emitBack() {
        this.back.emit();
    }

    updateFile(file) {
        this.file = file;
    }

    login() {
        this.state.loading = true;
        this.state.isUserMenuOpen = false;
        this.authService.login();
    }

    logout() {
        this.state.loading = true;
        this.state.isUserMenuOpen = false;
        this.authService.logout();
    }

    setLanguage(language: string) {
        console.log('setLanguage', language);
        this.state.isLanguageMenuOpen = false;
        this.state.isUserMenuOpen = false;
        this.localeService.language = language;
    }

    /**
     * Open warranty claim with claim id
     * We have to first get the actual claim and check it's company and partnerId
     */
    openWarrantyClaim(claimId) {
        this.claimsService.getClaimById(claimId.trim()).subscribe((claim: Claim) => {
            if (claim) {
                this.router.navigate([`/claims/${claim.company}/${claim.partnerId}/${claim.id}`]);
            } else {
                this.showError({ message: 'Claim not found' });
            }
        }, (error) => {
            console.log(error);
            this.showError(error);
        });
    }

    /**
     * Show error snackbar notification
     */
    showError(error) {
        const message = _.get(error, 'error.errorMessage') || _.get(error, 'message');
        const type = _.get(error, 'type') || _.get(error, 'error.error.caused_by.caused_by.type') || _.get(error, 'error.error.caused_by.type') || '';
        const reason = _.get(error, 'reason') || _.get(error, 'error.error.caused_by.caused_by.reason') || _.get(error, 'error.error.caused_by.reason') || '';

        this.snackBar.open(message + '\n\n' + type + '\n' + reason, 'OK', {
            duration: 5000,
            panelClass: ['war-snackbar', 'war-snackbar-error-message']
        });
    }
}
